<!--
  - Copyright (c) 2019 Eva Novotná, Juraj Šimon
  -->

<template>
  <div ref="section">
    <div ref="header" class="main-title right is-uppercase">
      {{ $t("about me") }}
    </div>
    <div class="about-me-section">
      <div class="with-padding">
        <div class="columns">
          <div class="column">
            <div class="section-sub-title">{{ $t("Education") }}</div>
            <ul class="simple-list">
              <li>
                FHS UK<br /><span class="desc">{{
                  $t("Master's degree")
                }}</span>
              </li>
              <li>
                {{ $t("Paramedic") }}<br />
                <span class="desc">{{ $t("Certified specialist") }}</span>
              </li>
              <li>
                FTVS UK<br /><span class="desc">trenérská škola - plavání</span>
              </li>
              <li>
                PSIA USSA<br /><span class="desc">{{
                  $t("skiing instructor")
                }}</span>
              </li>
              <li>
                Svaz lyžařů ČR<br /><span class="desc">trenér lyžování</span>
              </li>
              <li>
                VZS ČČK<br /><span class="desc">Vodní záchranář I.</span
                ><br /><span class="desc">Divoká a volná voda</span>
              </li>
            </ul>
          </div>
          <div class="column">
            <div class="section-sub-title">{{ $t("Work experience") }}</div>
            <ul class="simple-list">
              <li>
                Vodní záchranář<br />
                <span class="desc">Beach Patrol Lifeguard Delware</span><br />
                <span class="desc">2005 - 2006</span>
              </li>
              <li>
                Instruktor lyžování<br />
                <span class="desc">Park City UT, USA</span><br />
                <span class="desc">2005 - 2006, 2008 - 2009</span>
              </li>
              <li>
                Instruktor vodní záchrany<br />
                a První pomoci<br /><span class="desc">2011 - doposud</span>
              </li>
              <li>
                Trenér lyžování,<br />
                plavání a běhání<br /><span class="desc">2015-doposud</span>
              </li>
              <li>
                Instruktor lyžování, <br />plavání, lezení a všestranné<br />
                pohybové přípravy<br />
                <span class="desc">2001 - 2015 (jako hobby)</span><br />
                <span class="desc">2015 - doposud (profesionalne)</span>
              </li>
            </ul>
          </div>
          <div class="column">
            <div class="section-sub-title">{{ $t("Race experience") }}</div>
            <ul class="simple-list">
              <li>Neptun Masters<br /><span class="desc">Swim Team</span></li>
              <li>
                Ski team Masters <br />Intermountain Division<br />
                <span class="desc">Park City UT, USA</span>
              </li>
              <li>
                X-terra, Triathlon<br /><span class="desc"
                  >VŠ Slavia Plzeň</span
                >
              </li>
              <li>MTB maratons</li>
              <li>Horské půlmaratony</li>
              <li>
                SUP maratons<br /><span class="desc">Paddleboardshop team</span
                ><br />
              </li>
              <li>VHS</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      about: "home/about"
    })
  },
  methods: {
    ...mapActions({
      setAbout: "home/setAbout"
    }),
    handleScroll() {
      let dim = this.$refs.header.getBoundingClientRect();
      let sectionDdim = this.$refs.section.getBoundingClientRect();
      if (
        dim.y > 0 ||
        sectionDdim.y + this.$refs.section.offsetHeight - 64 < 0
      ) {
        if (this.about) {
          this.setAbout(false);
        }
      } else {
        if (!this.about) {
          this.setAbout(true);
        }
      }
      //
      // let dim = this.$refs.header.getBoundingClientRect();
      // if ((dim.y + this.$refs.header.offsetHeight) > 0 && this.about) {
      //   this.setAbout(false);
      // }
      // if ((dim.y + this.$refs.header.offsetHeight) < 0 && !this.about) {
      //   this.setAbout(true);
      // }
    }
  },
  mounted() {
    this.handleScroll();
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>
<style lang="scss" scoped>
@import "section.scss";
@import "./../styles/main";

.simple-table {
  display: flex;
  text-align: left;
  width: 100%;
  justify-content: space-between;
}

.simple-list {
  list-style: none;
  padding: 0;
  font-size: 1.5em;
  line-height: 1em;

  li {
    margin-bottom: 0.7em;
  }

  .desc {
    font-size: 0.8em;
    opacity: 0.7;
    margin-left: 0.4em;
  }
}

.about-me-section {
  background-color: $section-background-color;
  text-align: center;
}
</style>
